export default __webpack_public_path__ + "static/media/utensils.f87bbbe8.svg";